module.exports = __webpack_public_path__ + "2b92024d4698c9f9148f25f8d2504224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_goods_1.jpg
// module id = 207
// module chunks = 1